import { LevelProps } from '../../../Types'
import { LEVEL_CARDS } from '../../../Constants'
import { LevelPage } from '../../LevelPage'

export const ProductVisual = (props: LevelProps) => {
  return (
    <LevelPage
      {...props}
      heading="What platform do you want to create a product visual for?"
      cardSize="small"
      cards={LEVEL_CARDS.L3.PRODUCT_VISUAL}
    />
  )
}
